// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const th: ChromeTranslations = {
  'nav.nextPage': 'หน้าถัดไป →',
  'nav.previousPage': '← หน้าก่อนหน้า',
  'nav.continueToLevel': 'ไปที่ด่าน →',
  'nav.backToMenu': 'กลับไปเมนู →',
  'howto.page': 'หน้า {n} จาก {total}',
  'options.title': 'ตัวเลือก',
  'ui.language': 'ภาษา',
};
